
console.log("Override sessionStorage with localStorage is starting...");

(function() {
  sessionStorage.setItem = function(key, value) {
    console.log(`Setting ${key} in localStorage instead of sessionStorage`);
    localStorage.setItem(key, value);
  };

  sessionStorage.getItem = function(key) {
    console.log(`Getting ${key} from localStorage instead of sessionStorage`);
    return localStorage.getItem(key);
  };

  sessionStorage.removeItem = function(key) {
    console.log(`Removing ${key} from localStorage instead of sessionStorage`);
    localStorage.removeItem(key);
  };
  
    sessionStorage.clear = function() {
    console.log("Clearing all items in localStorage instead of sessionStorage");
    localStorage.clear();
  };
})();

console.log("Override sessionStorage with localStorage is complete.");




function syncSessionToLocalStorage() {
    console.log("Starting sync from sessionStorage to localStorage...");

    // Copy all existing sessionStorage data to localStorage
    for (let key in sessionStorage) {
        if (sessionStorage.hasOwnProperty(key)) {
            localStorage.setItem(key, sessionStorage.getItem(key));
            console.log(`Copied ${key}: ${sessionStorage.getItem(key)} from sessionStorage to localStorage.`);
        }
    }

    // Override sessionStorage.setItem to also set in localStorage
    const originalSetItem = sessionStorage.setItem;
    sessionStorage.setItem = function(key, value) {
        originalSetItem.apply(this, arguments);
        localStorage.setItem(key, value);
        console.log(`Set ${key}: ${value} in both sessionStorage and localStorage.`);
    };

    // Override sessionStorage.removeItem to also remove from localStorage
    const originalRemoveItem = sessionStorage.removeItem;
    sessionStorage.removeItem = function(key) {
        originalRemoveItem.apply(this, arguments);
        localStorage.removeItem(key);
        console.log(`Removed ${key} from both sessionStorage and localStorage.`);
 };

    console.log("Sync from sessionStorage to localStorage complete.");
}


syncSessionToLocalStorage();

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/main.ts